import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { WarehouseStorageRate } from '../models/warehouse-storage-rate.model';

@Injectable({
  providedIn: 'root'
})
export class WarehouseStorageRateService {

  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  getStorageRateById(id: number): Observable<WarehouseStorageRate> {

    if (id <= 0 || id === null || id === undefined) {
      throw new Error('WarehouseStorageRateService: Id must be a valid number');
    }

    return this.httpClient.get(this._endpoint + 'warehouse-storage-rate/' + id).pipe(map((value: any) => {
      return <WarehouseStorageRate>value;
    }));
  }

  createStorageRate(rate: WarehouseStorageRate): Observable<WarehouseStorageRate> {

    if (!rate) {
      throw new Error('warehouse storage rate service: you must supply a rate object for saving');
    }

    delete rate.createdAt;
    delete rate.updatedAt;

    if (rate.id > 0) {
      throw new Error('warehouse storage rate service: Cannot create an existing object');
    }

    delete rate.id;

    return this.httpClient.post(this._endpoint + 'warehouse-storage-rate',
      JSON.stringify(rate),
      { headers: { 'Content-Type': 'application/json' } }).pipe(map((data) => {
        return <WarehouseStorageRate>data;
      }));
  }

  updateStorageRate(rate: WarehouseStorageRate): Observable<WarehouseStorageRate> {

    if (!rate) {
      throw new Error('warehouse storage rate service: you must supply a rate object for saving');
    }

    delete rate.createdAt;
    delete rate.updatedAt;

    if (!rate.id || rate.id === -1) {
      throw new Error('warehouse storage rate service: Cannot update a record without id');
    }

    return this.httpClient.put(this._endpoint + 'warehouse-storage-rate/' + rate.id,
      JSON.stringify(rate),
      { headers: { 'Content-Type': 'application/json' } }).pipe(map((data) => {
        return <WarehouseStorageRate>data;
      }));
  }

  /** The measures a rate can be quoted in - tonnes for bulk, pallets for everyone counted that way. */
  getAllUnits(): Observable<any[]> {
    return this.httpClient.get(this._endpoint + 'unit?sort=name,ASC').pipe(map((data) => {
      return <any[]>data;
    }));
  }

  /** For the optional per-product override. */
  getAllProducts(): Observable<any[]> {
    return this.httpClient.get(this._endpoint + 'product?sort=name,ASC').pipe(map((data) => {
      return <any[]>data;
    }));
  }
}
